import SiteLayout from '@/components/feature/SiteLayout';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import HeroCarousel from './components/HeroCarousel';
import CategoryShortcuts from './components/CategoryShortcuts';
import LatestMovies from './components/LatestMovies';
import SiteIntro from './components/SiteIntro';

export default function Home() {
  useDocumentMeta({
    title: '善良的小姨子在线观看 - 最新电影完整版免费播放平台',
    description:
      '善良的小姨子免费在线观看网站，提供最新电影《善良的小姨子》的高清全集在线观看，涵盖剧情介绍和精彩片段，满足用户在线观看需求。',
    keywords: '善良的小姨子,善良的小姨子在线观看,善良的小姨子电影,电影在线观看,高清电影,最新电影,电影剧情',
  });

  return (
    <SiteLayout flushTop>
      <HeroCarousel />
      <CategoryShortcuts />
      <LatestMovies />
      <SiteIntro />
    </SiteLayout>
  );
}